import { render, staticRenderFns } from "./devServiceProvide.vue?vue&type=template&id=9fed3adc&scoped=true"
import script from "./devServiceProvide.vue?vue&type=script&lang=js"
export * from "./devServiceProvide.vue?vue&type=script&lang=js"
import style0 from "./devServiceProvide.vue?vue&type=style&index=0&id=9fed3adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fed3adc",
  null
  
)

export default component.exports